/* eslint-disable no-shadow */
/* eslint-disable no-use-before-define */
import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import Splash from '../../../../../components/Splash';

import slideStyles from './slide.scss';
import styles from './CustomSidebarStyles.scss';

const CustomSidebar = (props) => {
    const {
        sidebarOpen,
        handleBackClick,
        title,
        subtitle,
        handleOverlayClick,
        children,
        showSplash,
        'data-testid': dataTestId,
    } = props;

    return (
        <>
            <div
                id="sidebar"
                className={`${sidebarOpen ? 'open' : 'closed'} ${slideStyles.slide}`}
            >
                <div className={styles.sidebarWrapper}>
                    <nav className={`${styles.navbarCustomStyles} navbar navbar-light purple-grad `}>
                        <div className="container" style={{ position: 'relative' }}>
                            <div className="col d-flex justify-content-center align-items-center pr48 pl48">
                                {!!handleBackClick && (
                                    <div
                                        className="back-area"
                                        onClick={handleBackClick}
                                        data-testid={dataTestId && `${dataTestId}.back-btn`}
                                    >
                                        <i className="utr utr-prev" />
                                    </div>
                                )}
                                <div>
                                    <div className={`${styles.customTitle} text-highlight2 text-center`} data-testid={dataTestId && `${dataTestId}.title`}>
                                        {title}
                                    </div>
                                    <div className={`${styles.customSubTitle} text-center text-small`}>
                                        {subtitle}
                                    </div>
                                </div>
                                <div className="close-area" onClick={handleOverlayClick} data-testid={dataTestId && `${dataTestId}.close-btn`}>
                                    <img className="close-icon" src="/img/icons/sidebar-close-icon.svg" />
                                </div>
                            </div>

                        </div>
                    </nav>
                    <Splash showSidebarLoader={showSplash} />
                    <div className={`${styles.container} content`}>
                        {children}
                    </div>
                </div>
            </div>
            <div
                id="sidebar-overlay"
                className={sidebarOpen ? 'open' : 'closed'}
                onClick={handleOverlayClick}
            />
        </>
    );
};

CustomSidebar.propTypes = {
    sidebarOpen: PropTypes.bool.isRequired,
    handleBackClick: PropTypes.func,
    title: PropTypes.string,
    subtitle: PropTypes.string,
    handleOverlayClick: PropTypes.func.isRequired,
    children: PropTypes.node,
    showSplash: PropTypes.bool,
    'data-testid': PropTypes.string,
};

CustomSidebar.defaultProps = {
    handleBackClick: null,
    title: '',
    subtitle: '',
    children: null,
    showSplash: false,
};

export default withRouter(CustomSidebar);
